import api from './api';

interface ProductData {
  empresa_id: number;
  grupo_id: number;
  descricao: string;
  codigo?: string;
  gtin?: string;
  observacao?: string;
  estoque_minimo?: number;
  estoque_atual?: number;
  preco_custo: number;
  unidade_medida_id: number;
  imagem?: File | string;
  tipo: number;
}

const newMateriaPrima = async ({
  empresa_id,
  grupo_id,
  descricao,
  codigo,
  gtin,
  observacao,
  preco_custo,
  imagem,
  unidade_medida_id,
  tipo,
  estoque_minimo,
  estoque_atual,
}: ProductData): Promise<void> => {
  const dataForm = new FormData();

  dataForm.append('empresa_id', empresa_id.toString());
  dataForm.append('unidade_medida_id', unidade_medida_id.toString());
  dataForm.append('descricao', descricao);
  dataForm.append('preco_custo', preco_custo.toString());
  dataForm.append('tipo', tipo.toString());
  dataForm.append('ordem', '1');

  codigo && dataForm.append('codigo', codigo);
  gtin && dataForm.append('gtin', gtin);
  observacao && dataForm.append('observacao', observacao);
  imagem && dataForm.append('produto_img', imagem);

  const response = await api.post(`/produto/${grupo_id}`, dataForm, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });

  const { produto } = response.data;

  await api.post('/estoque', {
    empresa_id,
    produto_id: produto.id,
    estoque_minimo,
    estoque_atual,
    ativo: true,
  });
};

export default newMateriaPrima;
